/**
 * Customer registration and lookup (for pre-fill).
 * No auth; identified by email only.
 */

const apiBase = '';

export async function registerCustomer(data) {
  const res = await fetch(`${apiBase}/api/customers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: data.email?.trim(),
      name: data.name?.trim(),
      phone: data.phone?.trim(),
      address: data.address?.trim(),
      city: data.city?.trim(),
      state: data.state?.trim(),
      zipCode: data.zipCode?.trim(),
      country: data.country?.trim() || 'México',
      instagram: data.instagram || undefined,
    })
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || 'Error al registrar');
  return json;
}

export async function getCustomerByEmail(email) {
  const normalized = (email || '').trim().toLowerCase();
  if (!normalized) return { customer: null };
  const res = await fetch(`${apiBase}/api/customers?email=${encodeURIComponent(normalized)}`);
  const json = await res.json().catch(() => ({ customer: null }));
  if (!res.ok) throw new Error(json.error || 'Error al buscar cliente');
  return json;
}
